export const GET_ALL_FLAT_COUNTER_AVG = "GET_ALL_FLAT_COUNTER_AVG"
export const CREATE_FLAT_COUNTER_AVG = "CREATE_FLAT_COUNTER_AVG"
export const CREATE_FLAT_COUNTER_AVG_LEGACY = "CREATE_FLAT_COUNTER_AVG_LEGACY"
export const UPDATE_FLAT_COUNTER_AVG = "UPDATE_FLAT_COUNTER_AVG"
export const UPDATE_FLAT_COUNTER_AVG_LEGACY = "UPDATE_FLAT_COUNTER_AVG_LEGACY"
export const DELETE_FLAT_COUNTER_AVG = "DELETE_FLAT_COUNTER_AVG"
export const DELETE_FLAT_COUNTER_AVG_LEGACY = "DELETE_FLAT_COUNTER_AVG_LEGACY"
